import { Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { useDispatch } from 'react-redux';
import { viewImage } from '../../CommonUtils/viewImage';
import { commonColumns, serialNumberColumn } from '../../CommonUtils/CommunColumns';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FaDownload, FaFilePdf } from 'react-icons/fa';
export default function AfflOrderGen2022() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const acYear = sessionStorage.getItem('ac_year');

    const handleNavigate = (collCode, type) => {
        navigate("/AfflOrderGenDetails", { state: { type: type } });
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };
    const afflOrderGenFormik = useFormik({
        enableReinitialize: true,
        initialValues: {},
        validationSchema: "",
        onSubmit: (values) => {
        }
    })


    const [AfflorderData22, setAfflorderData22] = useState([]);
    function GetAfflOrderData22() {
        let url = config.url.API_URL + `nonOamdcAfflOrderReport `;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAfflorderData22(res?.data?.nonOamdcAfflOrderReport)

            } else {
                setAfflorderData22([])

            }
        })
    }

    function ApplicationPDf(collcode) {
        let url = config.url.API_URL + `getAffiliationPdf/` + collcode + "/" + acYear;
        let payload = {}
        CommonAxiosPost(url, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }


    function GetFfcaSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + acYear;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path);

            } else {
                console.log("No Data Found")

            }
        })
    }
    useEffect(() => {
        GetAfflOrderData22();

    }, [])

    const AfflOrderGenColumns22 = [

        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },

        {
            Header: "College Code",
            accessor: "coll_code",
        },

        {
            Header: "College Name",
            accessor: "coll_name",

            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_name}</div>
            ),
        },
        {
            Header: "Nature Of the College",
            accessor: "coll_nature_name",
        },

        {
            Header: "Application Submitted By the College", accessor: "appSubmittedBy",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" onClick={() => { ApplicationPDf(row?.original?.coll_code); }}><FaDownload size={20} /></button>
                )
            }
        },


        {
            Header: "FFCA Report", accessor: "ffcaReport",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" onClick={() => { GetFfcaSubmissionPdf(row?.original?.coll_code); }}><FaDownload size={20} /></button>
                )
            }
        },


        {
            Header: "Cdc Approval Pdf", accessor: "cdc_file_path",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" onClick={() => { viewImage(row?.original?.cdc_file_path); }}><FaDownload size={20} /></button>
                )
            }
        },
        {
            Header: "Affiliation Order", accessor: "final_pdf_path",
            Cell: ({ row }) => {
                const value = row?.values?.final_pdf_path;
                // return <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }} onClick={() => { handleNavigate(row?.original?.coll_code, "NONOAMDC") }}>Click Here to get Affiliation Order </button>

                if (value === "Click Here to get Affiliation Order") {
                    return <button type='button' className='btn btn-primary rounded-pill btn-sm' onClick={() => { handleNavigate(row?.original?.coll_code, "NONOAMDC") }}>  Click Here to get Affiliation Order</button>;
                } else {
                    return (
                        <button type="button" className="btn btn  btn-md pt-1"
                            onClick={() => {
                                viewImage(value);

                            }}>
                            <FaFilePdf color="red" size={20} />
                        </button>
                    );
                }
            }

        }

    ]

    return (
        <>
            <CommonFormHeading heading="Approve and Generate Affiliation Order" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={afflOrderGenFormik}>
                    <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="form_adjust" >
                        <bie.Row className="px-2 pt-3 mb-3 pb-3" >
                            {AfflorderData22?.length > 0 ? (
                                <div className="table-responsive">

                                    <CommonReactTable data={AfflorderData22} columns={AfflOrderGenColumns22} pagination="false" filename="Affl_orderGen" headerName={`Approve and Generate Affiliation Order`} />
                                </div>
                            ) : <center className='text-danger h5 pt-5'>***** No Data Found *****</center>}


                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>

        </>)
}
